import { Box } from '@chakra-ui/react'
import * as React from 'react'
import styled from '@emotion/styled'

import { math } from '../../utils/math'
import { useResponsive } from '../../hooks/useResponsive'
import { vw } from '../../styles/theme'
import Button, { ButtonProps } from './Button'

export type ButtonHamburgerProps = ButtonProps & {
  isOpen: boolean
}

const LineBase = ({ ...others }) => <Box w="100%" h="1px" {...others} />
const Line = styled(LineBase)``

const ButtonHamburger: React.FC<ButtonHamburgerProps> = ({ isOpen, ...others }) => {
  const isPC = useResponsive(false, true)
  // PC off w 88 h 31, on
  // SP off w 88 h 31, on
  const color = 'white'
  const w = 88
  const h = 38
  const lh = 1
  const oy = ((h - lh * 4) / 5) * 2 + lh
  const dist = math.dist(0, 0, 38, 38)
  const sx = dist / w
  const ox = -dist * 0.5

  const ty = isPC ? `${oy}px` : vw(oy)
  const tx = isPC ? `${ox}px` : vw(ox)

  return (
    <>
      <Button
        variant="unstyled"
        display="flex"
        flexDirection="column"
        justifyContent="space-around"
        borderRadius="0"
        minW="0"
        minH="0"
        w={[vw(w), `${w}px`]}
        h={[vw(h), `${h}px`]}
        bg={['transparent', 'background.black']}
        css={{
          [Line]: {
            transition: 'all 500ms cubic-bezier(0.23, 1, 0.32, 1)',
            background: 'currentcolor',
            transformOrigin: 'center',
            transform: isOpen ? 'scale(0)' : 'scale(1)',
            '&:first-of-type': {
              transform: isOpen
                ? `translateY(${ty}) translateX(${tx}) rotate(45deg) scaleX(${sx})`
                : 'scaleX(1) rotate(0)',
            },
            '&:last-of-type': {
              transform: isOpen
                ? `translateY(-${ty}) translateX(${tx}) rotate(-45deg) scaleX(${sx})`
                : 'scaleX(1) rotate(0)',
            },
          },
        }}
        {...others}
      >
        <Line color={color} />
        <Line color={color} />
        <Line color={color} />
        <Line color={color} />
      </Button>
    </>
  )
}

export default ButtonHamburger
